module.exports = __webpack_public_path__ + "static/media/jse.2104f466.png";